// deck.gl-community
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
export class Feature {
    // geo json coordinates
    geoJson;
    style;
    original;
    metadata;
    constructor(geoJson, style, original = null, metadata = {}) {
        this.geoJson = geoJson;
        this.style = style;
        this.original = original;
        this.metadata = metadata;
    }
    getCoords() {
        return this.geoJson.geometry.coordinates;
    }
}
//# sourceMappingURL=feature.js.map